import { CodeStatus, type EmbeddedCodeLike } from '@jms/model';
import { isPendingItemRow } from '../row/job.item.authorisation.group';

/**
 * Client half of legacy's `canNotCreatePurchaseOrder` (embedded.codes.table.component.ts): a line already
 * ordered, billed, supplied by the subcontractor, pending or cancelled has nothing left to order. Whether
 * the catalogue code is purchasable at all is the pipeline's answer — the row does not carry that flag.
 */
export function isItemPurchasable(item: (Partial<EmbeddedCodeLike> & { authorisation?: string }) | null | undefined): boolean {

  if (!item?._id || item.isClaimCode === true || isPendingItemRow(item)) return false;
  if (item.status === CodeStatus.Pending || item.status === CodeStatus.Cancelled) return false;

  return !item.purchaseOrder?._id && !item.bill?._id && !item.suppliedBySubcontractor;
}
